import React, { useState } from "react";
import config from "../../config";
import { Link } from 'gatsby';
import logo from "../assets/images/logo-white.png";

export default React.memo(function ContactFooter() {
  const [toogleContact, set] = useState(0);
  const telUrl =  `https://api.whatsapp.com/send?phone=57${config.contact[toogleContact].tel}&text=Quiero_información_de_Era`   
  return (
    <footer id="contactFooter"
    onLoad={
      (e) => { //console.log(e.target);
      if(window) {
      //  let clientRect = window.getBoundingClientRect();
     /* let body = document.body;
      let html = document.documentElement; 
      let bodyH = Math.max(body.scrollHeight/2, body.offsetHeight, body.getBoundingClientRect().height, html.clientHeight, html.scrollHeight, html.offsetHeight,  window.innerHeight) - 100;
    
        console.log(document.getElementById("contactFooter") , body.scrollHeight, body.offsetHeight, body.getBoundingClientRect().height,
        document.body.clientHeight,

        html.clientHeight, html.scrollHeight, html.offsetHeight);*/
      //  document.getElementById("contactFooter").style.top = bodyH +'px';
      }
      }
    }
    >
      <img className="major-logo item-top-1" src={`${logo}`} />

 
      <div className="contact-form item-top-2">
        <form action={`mailto:${config.contact[toogleContact].mail}`} name="contact" className="cta" data-netlify="true" netlify-honeypot="bot-field">
          <input type="hidden" name="form-name" value="contact" />
          <span>EMAIL:</span>
          <br />
          <input type="email" name="email" placeholder="tuemail@email.com" />
          <br />
          <span>MENSAJE:</span>
          <br />
          <input type="text" name="mensaje" value="Quiero información" />
          <br />
          <span>RAZÓN DE CONTACTO:</span><br/>
          <div className="label-container">
            <label><input type="checkbox" id="cbox1" value="first_checkbox" checked={toogleContact === 0 ? true:false}  onClick={e=> set(0)}/> Clientes </label> 
            <label><input type="checkbox" id="cbox2" value="first_checkbox2" checked={toogleContact === 1 ? true:false} onClick={e=> set(1)}/> Trabaja con nosotros</label>
            <label><input type="checkbox" id="cbox3" value="first_checkbox3" checked={toogleContact === 2 ? true:false} onClick={e=> set(2)}/> Proveedores</label>
          </div>
          <br />
          <input type="submit" value="ENVIAR" />
        </form>
      </div>
      <div className="item-top-3">
        <Link to="/Proyectos" className="title">
        {' '}
        <p> CREAMOS ARQUITECTURA DE HÁBITOS </p>{' '}
        </Link>
      </div>
      <div className="item-bottom">
        <ul className="icons">
          {config.socialLinks.map(social => {
            const { icon, name, url } = social;
            const uri = name ==="Whatsapp" ? telUrl  : url
            return (
              <li key={uri}>
                <a href={uri} className={`icon alt ${icon}`}>
                  <span className="label">{name}</span>
                </a>
              </li>
            );
          })}
        </ul>
          <a href="https://goo.gl/maps/LQ54gyqJ1Q3dS5KRA">CALLE 2 # 20-48 of. 902/ MEDELLÍN - COLOMBIA </a>
          <a href={telUrl}> / CEL +57 {config.contact[toogleContact].tel}</a>
      </div>

    </footer>
  );
})
